import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/logo-color.svg'


const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "d-flex justify-center mt-2" }
const _hoisted_3 = { class: "d-flex justify-center" }

import { useAcceptTermAndCondition, useGetTerms } from '@/composables/user';
import { ref, watch } from 'vue';
import { checkViewType } from '@/composables/auth';
import { useDialogsStore } from '@/store/dialogs';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/store/user';
import { TermCondition, TermConditionType } from '@/graphql/types/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsCompanyDialog',
  setup(__props) {

const dialogsStore = useDialogsStore();
const canAccept = ref(false);
const userStore = useUserStore();
const i18n = useI18n();
const language = ref(i18n.locale.value == 'it' ? 'ita' : 'eng');
const terms = ref(null);
const loading = ref(false);

watch(i18n.locale, () => {
    language.value = i18n.locale.value == 'it' ? 'ita' : 'eng';
});

const {
    mutate: acceptTerms,
    loading: loadingAccept,
    onDone: onDoneAccept,
} = useAcceptTermAndCondition(checkViewType);

function getContent() {
    const translations = terms.value?.translations;
    if (translations && translations.length > 0) {
        const text = translations.find((el) => el.lang === language.value);
        if (text) {
            return text.content;
        } else {
            const textDefault = translations.find((el) => el.lang === 'eng');
            if (textDefault) {
                return textDefault.content;
            }
        }
    }
    return '';
}

function getTerm() {
    const {
        result,
        loading: loadingGet,
        onError,
    } = useGetTerms(TermConditionType.Company);
    watch(result, (data) => {
        if (data?.TermConditionLast) {
            terms.value = data?.TermConditionLast;
        }
    });

    watch(loadingGet, () => {
        loading.value = loadingGet.value;
    });
}

watch(
    () => dialogsStore.termsCompany,
    () => {
        if (dialogsStore.termsCompany) {
            getTerm();
        }
    }
);

function scrollTo() {
    const element = document.getElementsByClassName('modal-text-content')[0];
    if (element) {
        element.scrollTop = element.scrollHeight;
        canAccept.value = true;
    }
}

function checkScroll() {
    const element = document.getElementsByClassName('modal-text-content')[0];
    if (element && element.scrollHeight - element.clientHeight === element.scrollTop) {
        canAccept.value = true;
    }
}

async function handleAcceptClick() {
    if (terms.value) {
        await acceptTerms({
            termConditionId: terms.value.id,
        });
    }
}

onDoneAccept(() => {
    dialogsStore.termsCompany = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "font",
    modelValue: _unref(dialogsStore).termsCompany,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialogsStore).termsCompany) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        width: "600",
        heigth: "80vh",
        class: "pa-6 rounded-xl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            justify: "center",
            "align-items": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_img, {
                      height: "70",
                      width: "70",
                      class: "mx-auto",
                      src: _imports_0
                    }),
                    _createElementVNode("div", {
                      class: "modal-text-content mt-6",
                      style: {"height":"35vh","overflow-y":"auto"},
                      onScrollPassive: checkScroll
                    }, [
                      _createElementVNode("div", {
                        class: "text-body-2",
                        innerHTML: getContent()
                      }, null, 8, _hoisted_1)
                    ], 32),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        color: "white",
                        onClick: scrollTo,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-chevron-down")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_btn, {
                        rounded: "pill",
                        disabled: !canAccept.value,
                        class: "text-uppercase mt-6",
                        color: "primary",
                        flat: "",
                        onClick: handleAcceptClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('accept')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})